module.exports = __webpack_public_path__ + "img/mm.62780d15.svg";